<div class="login-page">

  <!-- HEADER -->
  <div class="row">
    <div class="col-12">
      <div class="header">
        <div class="main_header">
          <img class="logo-imgs" src="assets/svg/BA Logo with Tagline Standard.svg" alt="Blue Pulse" />
        </div>
      </div>
    </div>
  </div>

  <!-- BODY -->
  <div class="row login-bg">

    <!-- LEFT CONTENT -->
    <div class="col-lg-6 col-md-12 login-left-content">
      <label class="login-title">
        Built for Modern Workforce Management
      </label>
      <p class="login-subtitle">
        Get visibility into working hours, evaluate performance, and gain actionable insights to improve productivity.
      </p>
    </div>

    <div class="col-lg-6 col-md-12 d-flex justify-content-center align-items-center">
      <mat-card class="admin_login_matcard">

        <label class="secon_admin_login_header_name">Welcome!</label>
        <div class="login-card-body">

          <label class="bad_credentials" [class.show]="authGuardService.badCredentials">
            Invalid email or password
          </label>

          <form [formGroup]="loginPasswordFormGroup"
                (ngSubmit)="onClickLoginGetToken()"
                novalidate>
            <mat-form-field appearance="outline" class="full-width input-field">
              <mat-label>Email</mat-label>
              <input matInput type="text" formControlName="email" autocomplete="off" />
              <mat-error>Email is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width input-field">
              <mat-label>Password</mat-label>
              <input matInput [type]="!hide ? 'password' : 'text'"
                     formControlName="password"
                     autocomplete="off" />
              <button mat-icon-button matSuffix type="button"
                      (click)="hide = !hide"
                      class="password-toggle">
                <mat-icon>
                  {{ hide ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </button>
              <mat-error>Password is required</mat-error>
            </mat-form-field>

            <div class="forgotPassword_name">
              <button type="button" class="forgotPassword" (click)="forgotPassword()">
                Forgot Password?
              </button>
            </div>

            <div class="login-btn-wrapper">
              <button *ngIf="!authGuardService.logInProcess"
                      mat-raised-button
                      type="submit"
                      class="secondary-login-in-button">
                Login
              </button>

              <button *ngIf="authGuardService.logInProcess"
                      mat-raised-button
                      disabled
                      class="secondary-login-in-button">
                Logging In...
              </button>
            </div>

          </form>
        </div>

      </mat-card>
    </div>

  </div>
</div>

<app-spinner></app-spinner>
